// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Input-module__input--1qEAK{width:100%;background:#fff;border:1px solid #ccc;border-radius:5px;box-shadow:0 1px 1px rgba(0,0,0,.1) inset;box-sizing:border-box;color:#444;font-weight:normal;font-size:1rem;padding:.5em}.Input-module__input--1qEAK:focus{border-color:#09c;box-shadow:0 0 5px rgba(0,153,204,.1),0 1px 1px #eee inset;outline:none}.Input-module__input--1qEAK:focus:-ms-input-placeholder{color:transparent}.Input-module__input--1qEAK:focus::placeholder{color:transparent}.Input-module__input--1qEAK:-ms-input-placeholder{color:#999}.Input-module__input--1qEAK::placeholder{color:#999}.Input-module__input--1qEAK:disabled{background:#f6f6f6;color:#999}", ""]);
// Exports
exports.locals = {
	"input": "Input-module__input--1qEAK"
};
module.exports = exports;
